export const TEXTO_MULTA = 'Se esse for o último mês do seu plano anual, a multa não será cobrada.'
